import React from 'react'
import { I18n } from 'react-redux-i18n'

export default ({ onClick }) => (
  <button
    onClick={onClick}
    className="w-full bg-white border border-gray-200 rounded-lg p-3 hover:border-primary-500 hover:shadow-md transition-all duration-200 text-center group"
  >
    <svg
      className="w-5 h-5 text-gray-400 group-hover:text-primary-600 mx-auto mb-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
    <span className="text-gray-900 font-medium text-sm">
      {I18n.t('checkInScene.field.cash')}
    </span>
  </button>
)
